export enum Extension {
  'wpo365Integrate' = 'wpo365Integrate',
  'wpo365Pro' = 'wpo365Pro',
  'wpo365Customers' = 'wpo365Customers',
  'wpo365Scim' = 'wpo365Scim',
  'wpo365RolesAccess' = 'wpo365RolesAccess',
  'wpo365Apps' = 'wpo365Apps',
  'wpo365Essentials' = 'wpo365Essentials',
  'wpo365LoginPlus' = 'wpo365LoginPlus',
  'wpo365Mail' = 'wpo365Mail',
  'wpo365Login' = 'wpo365Login',
  'wpo365MsGraphMailer' = 'wpo365MsGraphMailer',
}

export enum ExtensionType {
  'bundle' = 'bundle',
  'addon' = 'addon',
  'free' = 'free',
}

export interface IExtension {
  price: number
  type: ExtensionType
  extension: Extension
  name: string
  url: string
}

export const Extensions: IExtension[] = [
  { price: 349, type: ExtensionType.bundle, extension: Extension.wpo365Customers, name: 'CUSTOMERS', url: 'https://www.wpo365.com/downloads/wpo365-customers/' },
  { price: 349, type: ExtensionType.bundle, extension: Extension.wpo365Integrate, name: 'INTEGRATE', url: 'https://www.wpo365.com/downloads/wpo365-integrate/' },
  { price: 249, type: ExtensionType.bundle, extension: Extension.wpo365Pro, name: 'PROFESSIONAL', url: 'https://www.wpo365.com/downloads/wpo365-professional/' },
  { price: 99, type: ExtensionType.addon, extension: Extension.wpo365Scim, name: 'SCIM', url: 'https://www.wpo365.com/downloads/wpo365-scim/' },
  { price: 99, type: ExtensionType.addon, extension: Extension.wpo365RolesAccess, name: 'ROLES + ACCESS', url: 'https://www.wpo365.com/downloads/wpo365-roles-access/' },
  { price: 99, type: ExtensionType.addon, extension: Extension.wpo365Apps, name: 'M365 APPS', url: 'https://www.wpo365.com/downloads/wpo365-microsoft-365-apps/' },
  { price: 99, type: ExtensionType.addon, extension: Extension.wpo365Essentials, name: 'ESSENTIALS', url: 'https://www.wpo365.com/downloads/wpo365-essentials/' },
  { price: 49, type: ExtensionType.addon, extension: Extension.wpo365Mail, name: 'MAIL', url: 'https://www.wpo365.com/downloads/wpo365-mail/' },
  { price: 49, type: ExtensionType.addon, extension: Extension.wpo365LoginPlus, name: 'PROFILE+', url: 'https://www.wpo365.com/downloads/wordpress-office-365-login-plus/' },
  { price: 0, type: ExtensionType.free, extension: Extension.wpo365MsGraphMailer, name: 'MICROSOFT GRAPH MAILER', url: 'https://wordpress.org/plugins/wpo365-msgraphmailer/' },
  { price: 0, type: ExtensionType.free, extension: Extension.wpo365Login, name: 'LOGIN', url: 'https://wordpress.org/plugins/wpo365-login/' },
]